import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-dealer',
  templateUrl: './create-dealer.component.html',
  styleUrls: ['./create-dealer.component.css']
})
export class CreateDealerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
